import scales from './scales';

export default {
  neutral: {
    lightest: scales.neutral.N1,
    light: scales.neutral.N4,
    base: scales.neutral.N9,
    dark: scales.neutral.N10
  },

  blue: {
    lightest: scales.primary.P1,
    light: scales.primary.P4,
    base: scales.primary.P9,
    dark: scales.primary.P10
  },

  red: {
    lightest: '#fef6f6',
    light: '#fae2e2',
    base: '#ec4c47',
    dark: '#bf0e08'
  },

  orange: {
    lightest: '#fdf8f3',
    light: '#fae3cd',
    base: '#d9822b',
    dark: '#95591e'
  },

  yellow: {
    lightest: '#fef8e7',
    light: '#fbe6a2',
    base: '#f7d154',
    dark: '#7e6514'
  },

  green: {
    lightest: '#f1faf5',
    light: '#d4eee2',
    base: '#47b881',
    dark: '#00783e'
  },

  teal: {
    lightest: '#f1fbfc',
    light: '#d2eef3',
    base: '#14b5d0',
    dark: '#007489'
  },

  purple: {
    lightest: '#f8f7fc',
    light: '#eae7f8',
    base: '#735dd0',
    dark: '#37248f'
  }
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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